import { useRef } from 'react';
import { equal } from '@okee-uikit/react-utils';
export function usePrevProp(prop, comparator) {
  var prev = useRef(prop);
  var old = prev.current;
  var isEqual = (comparator || equal)(old, prop);
  prev.current = prop;
  return [isEqual, old];
}